import { z } from "zod"
import { ChannelEnum, FlowEnum } from "../../campaigns/commonTypes"
import { ClusterDomainEnum } from "../../insights/response_data"
import { TimeDimensionSchema, TimeFrameEnum, TimeFrameSchema } from "../../insights/timeFrame"
import { createFilterBySchema } from "../../shared/filter_dtos"
import { PaginationSchema } from "../../shared/pagination_dtos"
import { QuerySchema } from "../../shared/query_dtos"
import { SupportPredefinedCategoryEnum } from "../../support/dtos"

export const BackofficeSupportIntegrationEnum = ["shopify", "bigblue", "amphora"] as const
export const BackofficeSupportStatusEnum = ["all", "autoSolved", "hasTicket"] as const
export const BackofficeSupportIsLogisticsEnum = ["all", "yes", "no"] as const
export const BackofficeSupportCategoryEnum = SupportPredefinedCategoryEnum
export const BackofficeSupportTreemapDomainEnum = [
  ClusterDomainEnum.Support,
  ClusterDomainEnum.Issue,
  ClusterDomainEnum.Question,
  ClusterDomainEnum.ActionRequest,
] as const

export const BackofficeSupportFilterBySchema = createFilterBySchema([
  { key: "channel", value: z.enum(ChannelEnum).optional() },
  { key: "flow", value: z.enum(FlowEnum).optional() },
  {
    key: "integration",
    value: z.array(z.enum(BackofficeSupportIntegrationEnum)).optional(),
  },
  {
    key: "companyId",
    value: z.string().optional(),
  },
  {
    key: "status",
    value: z.enum(BackofficeSupportStatusEnum).optional(),
  },
  {
    key: "isLogistics",
    value: z.enum(BackofficeSupportIsLogisticsEnum).optional(),
  },
  {
    key: "category",
    value: z.array(z.enum(BackofficeSupportCategoryEnum)).optional(),
  },
  {
    key: "canonicalTopic",
    value: z
      .object({
        domain: z.enum(BackofficeSupportTreemapDomainEnum),
        label: z.string().min(1),
      })
      .optional(),
  },
] as const)

export const GetBackofficeSupportQuestionsSchema = z.object({
  ...PaginationSchema.extend(QuerySchema.shape)
    .extend(BackofficeSupportFilterBySchema.shape)
    .extend({
      timeFrame: TimeFrameSchema.optional().default(TimeFrameEnum.Last1Week),
      timeDimension: TimeDimensionSchema.optional(),
    }).shape,
})

const backofficeSupportChartQueryShape = QuerySchema.extend(
  BackofficeSupportFilterBySchema.shape,
).extend({
  timeFrame: TimeFrameSchema.optional().default(TimeFrameEnum.Last1Week),
}).shape

export const GetBackofficeSupportTreemapSchema = z.object({
  ...backofficeSupportChartQueryShape,
  domain: z.enum(BackofficeSupportTreemapDomainEnum).default(ClusterDomainEnum.Support),
})

export const GetBackofficeSupportActivitySchema = z.object({
  ...backofficeSupportChartQueryShape,
  timeDimension: TimeDimensionSchema.optional(),
})

export const GetBackofficeSupportDomainActivitySchema = GetBackofficeSupportActivitySchema.extend({
  domain: z.enum(BackofficeSupportTreemapDomainEnum),
})
